export function formattime(timeMills){
    var date = new Date(timeMills);
	var timeStr = date.getFullYear() + "-";
	if (date.getMonth() < 9)
    { // 月份从0开始的
		timeStr += '0';
	}
	timeStr += date.getMonth() + 1 + "-";
	timeStr += date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate();
	timeStr += ' ';
	timeStr += date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours();
	timeStr += ':';
	timeStr += date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
	timeStr += ':';
	timeStr += date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds();
	return timeStr;
}
export function getLocalTime(timestamp, with_second = false) {
  if (timestamp === 0 || !timestamp) {
    return ''
  }

  const current = new Date(timestamp * 1000)
  let Y = current.getFullYear()
  let M = current.getMonth() + 1
  let D = current.getDate()
  let h = current.getHours()
  let m = current.getMinutes()
  let s = current.getSeconds()

  if (M < 10) {
    M = '0' + M
  }
  if (D < 10) {
    D = '0' + D
  }
  if (h < 10) {
    h = '0' + h
  }
  if (m < 10) {
    m = '0' + m
  }
  if (s < 10) {
    s = '0' + s
  }
  if (with_second) {
    return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
  } else {
    return Y + '-' + M + '-' + D + ' ' + h + ':' + m
  }
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function getHumanDuration(seconds) {
  if (seconds < 60) {
    return String(seconds) + 'Sec'
  } else if (seconds < 3600) {
    return String(Math.floor(seconds / 60)) + 'Min'
  } else if (seconds < 86400) {
    const hour = Math.floor(seconds / 3600)
    const min = Math.floor(seconds % 3600 / 60)
    return String(hour) + 'Hour ' + String(min) + 'Min'
  } else {
    const day = Math.floor(seconds / 86400)
    const hour = Math.floor(seconds % 86400 / 3600)
    const min = Math.floor(seconds % 3600 / 60)
    return String(day) + 'Day ' + String(hour) + 'Hour ' + String(min) + 'Min'
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js